export const UPLOAD_IMAGE_PATHNAME =
  '/api/v2/upload/image?cloud=true&isPrivate=false';

export const UPLOAD_FILE_PATHNAME =
  '/api/v2/upload/doc?cloud=true&isPrivate=false';

export const UPLOAD_IMAGE_PRIVATE_PATHNAME =
  '/api/v2/upload/image?cloud=true&isPrivate=true';

export const UPLOAD_FILE_PRIVATE_PATHNAME =
  '/api/v2/upload/doc?cloud=true&isPrivate=true';

export const UPLOAD_VIDEO_PATHNAME =
  '/api/v2/upload/video?cloud=true&isPrivate=false';

const IMAGE_TYPE_PNG = 'image/png';
const IMAGE_TYPE_JPEG = 'image/jpeg';
const IMAGE_TYPE_JPG = 'image/jpg';

export const ACCEPTED_IMAGE_TYPES = [
  IMAGE_TYPE_JPEG,
  IMAGE_TYPE_JPG,
  IMAGE_TYPE_PNG,
];
